import React, { useEffect } from 'react'
import {motion} from "framer-motion"
import '../components/Styles/home.css'
import '../components/Styles/Location.css'
import xm1 from '../assets/images/location1.png'
import xm2 from '../assets/images/location2.png'
import xm8 from '../assets/images/location8.png'
import ov1 from '../assets/images/ov1.png'
import ov2 from '../assets/images/ov2.png'
import ov3 from '../assets/images/ov3.png'
import ov4 from '../assets/images/ov4.png'
import ov5 from '../assets/images/ov5.png'
import ov6 from '../assets/images/ov6.png'
import ov7 from '../assets/images/ov7.png'
import ov8 from '../assets/images/ov8.png'
import ov9 from '../assets/images/ov9.png'
import ov9a from '../assets/images/m1.png'
import ov9b from '../assets/images/m2.png'
import ov9c from '../assets/images/m3.png'
import bg1a from '../assets/images/bg1a.png'
import bg1b from '../assets/images/bg1b.png'
import bg1c from '../assets/images/bg1c.png'
import bg1d from '../assets/images/bg1d.png'
import tick from '../assets/images/tickkk.png'
import ex from '../assets/images/ex (1).png'
import loc9 from '../assets/images/loc9 (1).png'
import AOS from 'aos';
import 'aos/dist/aos.css';
import Slide from './Slide'


const Location = () => {
  useEffect(()=>{
    AOS.init();
   
  })

  return (
    <div>
      <section className='location__main'>
        <div className='location__main_div'>
            
            <span style={{display:"flex",alignItems:"center",paddingTop:"8%"}}><hr style={{backgroundColor:"#EEBD2B",height:"2px",width:"20px"}}/><h3>&nbsp; Uptown Houston</h3></span>
            
            <h1>A Premier Business <br />
            <span style={{color:"#EEBD2B"}}>Address in Uptown Houston</span>
</h1>
<p>Private executive offices, virtual office solutions, and conference
facilities located at 3050 Post Oak Boulevard in Houston's
prestigious Post Oak corridor.</p>
          <button>
      Schedule a Private Tour    </button>{" "}
          <button style={{ background: "#0D0D0D", color: "#EEBD2B", opacity: 1 }}>
            View Office Options
          </button>
        </div>
        </section>

        <section style={{background:"black"}}>
            <div className='location__second'>
               <div className='loaction__row1'>
                 <div className='location_col1'> 
                    
            <span style={{display:"flex",alignItems:"center",paddingTop:"8%"}}><hr style={{backgroundColor:"#EEBD2B",height:"2px",width:"20px"}}/><h3>&nbsp; The Prestige</h3></span>

                    <h2>Position Your Business
Where Image             <span style={{color:"#EEBD2B"}}>Matters</span>
 </h2>
 <br />
<p>Operating from Houston's Uptown district instantly elevates your company's presence
Surrounded by financial institutions, luxury hotels, and high-level professional firms, thi
location reflects credibility from the moment your client arrives. </p>
<br />
<p>Xceed Office at 3050 Post Oak Boulevard is designed for professionals who understan
that environment influences perception.</p>

<p style={{color:"white",fontStyle:"italic",marginTop:"3%"}}>"This is not casual coworking. <br />
This is executive positioning."</p>
                 </div>
                <div className='location_col1'>
                    <img src={xm1} alt="" />
                </div>

               </div>

            </div>
        </section>  

                <section style={{background:"#141414",paddingTop:"4%",paddingBottom:"4%"}}>
            <div className='location__third'>
               <div className='loaction__row3'>
                 <div className='location_col3'>
                   <img src={xm2} alt="" />
                    </div>
                       <div className='location_col3'>|
                                    <span style={{display:"flex",alignItems:"center"}}><hr style={{backgroundColor:"#EEBD2B",height:"2px",width:"20px"}}/><h3>&nbsp; The Building</h3></span>

                        <h2>Inside <span style={{color:"#EEBD2B"}}> 3050 Post Oak Boulevard</span></h2>
                      
                        <p>3050 Post Oak Boulevard is a Class A office tower located in the center of Houston's
Uptown business district. With immediate access to Loop 610, I-10, and US-59, the
building offers unmatched accessibility for both you and your clients. </p>
<p>The tower is minutes from The Galleria and surrounded by executive dining, major
banking institutions, and professional services firms.</p>

<button><h4>Class A</h4> <p>Office Tower</p></button> <button><h4>3</h4> <p>Major Highways</p></button>
                    </div>
              
                </div>
              </div>

              </section>       

<br /><br /><br />
 <section>
            <div className='location__4'>
         <h3 className='' style={{display:"flex",alignItems:"center"}}><hr style={{backgroundColor:"#EEBD2B",height:"2px",width:"20px"}}/><h3>&nbsp; Executive Workspace Solutions</h3><hr style={{backgroundColor:"#EEBD2B",height:"2px",width:"20px"}}/></h3>


             <h2>Available at This <span style={{color:"#EEBD2B"}}>Location</span> </h2>
             <br />
               <div className='loaction__row4'>
                 <div className='location_col4a'>
                    <img src={ov1} alt="" />
                   <h2>Private Executive Offices</h2>
                   <p>Fully furnished offices built for attorneys, consultants, advisors, and professional teams wh
require privacy and focus.</p>
                 </div>
                 <div className='location_col4b'>
                    <img src={ov2} alt="" />
                    <h2>Virtual Office Services</h2>
                    <p>Establish your business at 3050 Post Oak Boulevard with a prestigious business address, mail
handling, and optional live receptionist support.</p>
                 </div>
                   

              </div>
              <br />
              <div className='loaction__row4'>
              
                    <div className='location_col4a'>
                 <img src={ov3} alt="" />
  <h2>Conference & Meeting Room</h2>
                   <p>Modern meeting facilities designed for presentations, negotiations, and board-leve
discussions.</p>
                 </div>
                 <div className='location_col4c'>
                    <img src={ov4} alt="" />
                    <h2>Day Offices</h2>
                    <p>Professional private office space available on demand — when you need it, where you need
it.</p>
                 
                    
                   </div>
              </div>
             
              </div>
              </section>
<br /><br />
 <section style={{background:"black",paddingBottom:"5%"}}>
            <div className='location__5'>
               <div className='loaction__row5'>
                 <div className='location_col5'>
            <span style={{display:"flex",alignItems:"center",paddingTop:"8%"}}><hr style={{backgroundColor:"#EEBD2B",height:"2px",width:"20px"}}/><h3>&nbsp; Who This Is Built For</h3></span>
                    <h2>Ideal for Growing & <span style={{color:"#EEBD2B"}}>Established Firms</span> </h2>
                    <p>If credibility is part of your competitive advantage, this location supports it</p>
                    <div className='location_box'><span style={{display:"flex",alignItems:"center",}}><img style={{width:"6%"}} src={ov5}/> <h4 > &nbsp;Law firms</h4></span></div>
                   <br />
     <div className='location_box'><span style={{display:"flex",alignItems:"center",}}><img style={{width:"6%"}} src={ov6}/> <h4 > &nbsp;CPAs and financial advisors</h4></span></div>
<br />
     <div className='location_box'><span style={{display:"flex",alignItems:"center",}}><img style={{width:"6%"}} src={ov7}/> <h4 > &nbsp;Real estate brokerages</h4></span></div>
<br />
     <div className='location_box'><span style={{display:"flex",alignItems:"center",}}><img style={{width:"6%"}} src={ov8}/> <h4 > &nbsp;Private equity and investment professional</h4></span></div>
<br />
     <div className='location_box'><span style={{display:"flex",alignItems:"center",}}><img style={{width:"6%"}} src={ov9}/> <h4 > &nbsp;Sales organizations</h4></span></div>
<br />
     <div className='location_box'><span style={{display:"flex",alignItems:"center",}}><img style={{width:"6%"}} src={ov8}/> <h4 > &nbsp;International companies entering Houston</h4></span></div>
                 </div>
                 <div className='location_col5'>
                    <img src={xm8} alt="" />
                 </div>


              </div>

              </div>
              </section>
               <section style={{background:"#141414",paddingTop:"0%",paddingBottom:"4%"}}>
            <div className='location__6'>

                                                    <h3 className='mggg' style={{display:"flex",alignItems:"center",textAlign:"center"}}><hr style={{backgroundColor:"#EEBD2B",height:"2px",width:"20px"}}/><h3>&nbsp;Interior Experience</h3><hr style={{backgroundColor:"#EEBD2B",height:"2px",width:"20px"}}/></h3>

               
                <h2>Structured, Professional, Focused</h2>
                <p>Every detail supports focus and performance.</p>
                <br />
               <div className='loaction__row6'>
                 <div className='location_col6'>
              <p><img src={tick} alt="" />&nbsp;Professional front desk reception</p>
                
                 </div>
                 <div className='location_col6'>
                  <p> <img src={tick} alt="" />&nbsp;Secure high-speed enterprise internet</p>
                    
                 </div>

              </div>
<div className='loaction__row6'>
                 <div className='location_col6'>
       <p> <img src={tick} alt="" />&nbsp;Quiet productivity-driven layout</p>
                            </div>
                 <div className='location_col6'>
                         <p> <img src={tick} alt="" />&nbsp;Executive-style furnishings</p>

                 </div>

              </div>
<div className='loaction__row6'>
                 <div className='location_col6'>
                                           <p> <img src={tick} alt="" />&nbsp;Lounge and pantry areas</p>

                 </div>
                 <div className='location_col6'>
                                                             <p> <img src={tick} alt="" />&nbsp;Dedicated prayer rooms</p>

                 </div>

              </div>

              <div className='loaction__row6'>
                 <div className='location_col6'>
                                                                               <p> <img src={tick} alt="" />&nbsp;Secure access control</p>

                 </div>
                 <div style={{display:"none"}} className='location_col6'>
Dedicated prayer rooms                 </div>

              </div>



              </div>
 </section>


               <section style={{background:""}}>
            <div className='location__7'>
               <div className='loaction__row7'>
                 <div className='location_col7'>
                                                            <h3 style={{display:"flex",alignItems:"center",textAlign:"center"}}><hr style={{backgroundColor:"#EEBD2B",height:"2px",width:"20px"}}/><h3>&nbsp;Flexibility to Scale</h3></h3>

                    <h2>Grow Without Losing <br />
                             <span style={{color:"#EEBD2B"}}>Your Address</span>  </h2>
<p><img style={{width:"6%"}} src={bg1a} alt="" /> &nbsp;Start with a virtual office.</p>
<p><img style={{width:"6%"}} src={bg1b} alt="" />&nbsp; Upgrade to a private suite.</p>
<p><img style={{width:"6%"}} src={bg1c} alt="" /> &nbsp;Expand into multiple offices as your team grows.</p>
<p><img style={{width:"6%"}} src={bg1d} alt="" />&nbsp; Maintain flexibility without sacrificing prestige.</p>
<h4>At 3050 Post Oak Boulevard, your address remains constant even as your company evolves</h4>
                 </div>
                 <div className='location_col7'>
                    <img src={loc9} alt="" />
                 </div>

              </div>

              </div>
 </section>

                <section>
            <div className='location__8'>
            <span style={{display:"flex",alignItems:"center",paddingTop:"8%"}} className='mgg'><hr style={{backgroundColor:"#EEBD2B",height:"2px",width:"20px"}}/><h3>&nbsp; Location Details</h3><hr style={{backgroundColor:"#EEBD2B",height:"2px",width:"20px"}}/></span>

                <h2>Location <span style={{color:"#EEBD2B"}}>Information</span> </h2>
<br />
               <div className='loaction__row8'>
                 <div className='location_col8'>
        <iframe style={{width:"100%",height:"300px"}}
  src="https://www.google.com/maps?q=3050+Post+Oak+Boulevard+Houston+TX+77056&output=embed"
  >
</iframe>
                 </div>
                 <div className='location_col8'>
                    <div className='boxy' >
                     <span style={{display:"flex",alignItems:"baseline",marginLeft:"4%"}}>
                        <img style={{width:"3%",height:"15%"}} src={ov9a} alt="" /> &nbsp;&nbsp;&nbsp;
                     <h4>Address <br />          <p>Xceed Office <br />
                     3050 Post Oak Boulevard<br />
                     Houston, Texas 77056</p>
            </h4> 
                     </span>
                     
                    </div>
                      <div className='boxy'>
                                             <span style={{display:"flex",alignItems:"baseline",marginLeft:"4%"}}>
                        <img style={{width:"3%",height:"15%"}} src={ov9b} alt="" /> &nbsp;&nbsp;&nbsp; <h4>Area <br /><p>Located in Houston's Uptown / Galleria area with direct access to Loop 610 and minutes
from major highways.</p></h4></span>

                        </div>
<div className='boxy'>
                       <span style={{display:"flex",alignItems:"baseline",marginLeft:"4%"}}><img style={{width:"3%",height:"15%"}} src={ov9b} alt="" /> &nbsp;&nbsp;&nbsp;<h4>Parking <br /><p>On-site parking available.</p></h4></span></div>
                 </div>

              </div>

              </div>
 </section>
 <br /><br />
 <section className='location__lst'>
    <div className='location__div'>
        <h2>Elevate Your Business Presence</h2>
        <p>Schedule a private tour at 3050 Post Oak Boulevard and experience executiv <br />
workspace designed for serious professionals.</p>
<button>Schedule a Private Tour</button> <button style={{background:"black",color:"white"}}>Call (346) 387-7187</button>
    </div>
 </section>
    </div>
  )
}

export default Location